<template>
  <transition name="fade" appear>
    <div class="body-container tasks">
      <app-task v-for="task in tasks" :key="task.id" :task="task"></app-task>
      <app-spacer></app-spacer>
    </div>
  </transition>
</template>

<script>
import Task from './Task.vue'
import Spacer from '../shared/Spacer.vue'

export default {
  props: ['tasks'],
  components: {
    appTask: Task,
    appSpacer: Spacer
  }
}
</script>

<style lang="scss" scoped>
  // .tasks {
  //   padding-bottom: 60px;

  //   @media screen and (max-width: 320px) {
  //     padding-bottom: 50px;
  //   }
  // }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/task/Tasks.vue